export default __webpack_public_path__ + "static/media/logo_eodyne.6b195cd1.svg";